import styled from '@emotion/styled';
import { icon, palette, srOnly } from '../../css';

const StyledIcon = styled('span')();

const StyledSvg = styled('svg')(({ aColor, colorTone, size }) => {
    const style = { ...icon.size[size] }; // side effect with <IconSvg />
    if (aColor) {
        style.fill = palette(aColor, colorTone);
    }
    return style;
});

const StyledTitle = styled('span')(() => srOnly);

export { StyledSvg, StyledTitle, StyledIcon };
